import React from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';

import { Card, Text, Icon, Button, BlockLink } from '@hz-design-system/web-ui';

import Classes from './SearchPreview.scss';
import TListing from '../../types/TListing';

const MAX_IMAGE_COUNT = 4;

type TProps = {
  categoryId?: number;
  title: string;
  listings: TListing[];
  ctaUrl: string;
  ctaText?: string;
  listingsCount?: number | null;
  onClickPreviewListing?: () => void;
  onClickCta?: () => void;
};

const SearchPreview = ({
  categoryId,
  title,
  listings = [],
  ctaUrl,
  ctaText,
  listingsCount,
  onClickPreviewListing = () => null,
  onClickCta = () => null,
}: TProps) => (
  <Card className={Classes.root}>
    <div className={Classes.header}>
      <div className={Classes.headerOverflowWrapper}>
        <Text.Large className={Classes.headerTitle}>{title}</Text.Large>
        {Boolean(listingsCount) && (
          <Text.Regular color="text-secondary" className={Classes.listingsCount}>
            <Trans i18nKey="searchPreview.listingsCount" count={listingsCount?.toLocaleString()} />
          </Text.Regular>
        )}
      </div>
      <div className={Classes.categoryIcon}>
        {categoryId && categoryId > 0 && <Icon name={categoryId.toString()} size="xl" />}
        {(!categoryId || categoryId <= 0) && <Icon name="category-deals" size="xl" />}
      </div>
    </div>
    <div className={Classes.previewImages}>
      {listings.slice(0, MAX_IMAGE_COUNT).map((listing) => (
        <div className={Classes.imageWrapper} key={`${listing.itemId}-listing-preview`}>
          {listing && (
            <BlockLink href={`/link/ad/${listing.itemId}`} onClick={onClickPreviewListing}>
              {listing.imageUrls && listing.imageUrls[0] && (
                <div className={Classes.image} style={{ backgroundImage: `url(${listing.imageUrls[0]})` }} />
              )}
              {(!listing.imageUrls || !listing.imageUrls[0]) && (
                <div className={Classes.noImage}>
                  <Icon name="image" size="xxl" />
                </div>
              )}
            </BlockLink>
          )}
        </div>
      ))}
    </div>
    <Button.Tertiary as="a" href={ctaUrl} onClick={onClickCta}>
      <Text.Regular color="signalLinkDefault" className={Classes.ctaText}>
        {ctaText || <Trans tagName="span" i18nKey="searchPreview.showAll" />}
      </Text.Regular>
      <Icon name="arrowTailedRight" color="link" size="m" />
    </Button.Tertiary>
  </Card>
);

export default SearchPreview;
